// ============================================================
// MedicalExpertSection.tsx
// Stage 3 redesign (approved mockup casevo-case-sections-batch2.html):
// the shared "party contact" card section — see
// components/case/sections/PartyContactSection.tsx. Fields, fieldKeys,
// address-lookup broadcast, the Yjs notes doc `case:<id>:medicalExpertNotes`
// and mark-complete ('medicalExpert') are exactly as the old long form.
// ============================================================
import React from 'react'
import PartyContactSection, { type PartyConfig } from '../case/sections/PartyContactSection'

const CONFIG: PartyConfig = {
  prefix: 'medicalExpert',
  sectionKey: 'medicalExpert',
  title: 'Medical expert',
  sub: 'The expert examining the client and writing the report.',
  cardTitle: 'Medical expert',
  icon: 'steth',
  nameLabel: 'Expert name',
  nameKey: 'medicalExpert.expert-name',
  who: 'the expert',
  notesPlaceholder: 'Notes about the medical expert…',
  readySub: 'No required fields: complete it once the expert is confirmed.',
}

const MedicalExpertSection: React.FC = () => <PartyContactSection config={CONFIG} />
export default MedicalExpertSection
